import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

/**
 * Faheem's core brand glyph.
 *
 * The open loop is derived from the Arabic initial ف. Its single dot acts as
 * the learner, while the open body suggests an active path toward
 * understanding. Keeping this as geometry instead of an image makes it sharp
 * at favicon, navigation, and voice-avatar sizes.
 */
const FaheemMark = ({ sx, children, ...props }: SvgIconProps) => (
  <SvgIcon viewBox="0 0 115.4 90" {...props} sx={sx}>
    {children}
    <path
      className="faheem-glyph-dot"
      fill="currentColor"
      d="M77 10c-.8-2.4-3.4-6.6-9-6.6-5.4 0-9.2 4-9.2 8.7s3.6 9.8 9.2 9.7c5.5.1 10.3-4.9 9-11.8Z"
    />
    <path
      className="faheem-glyph-body"
      fill="currentColor"
      d="M100.1 52.6H112l.1 3.4c.3 9-5.8 30.5-30.1 30.8H3V72.1h40.3c-1.5-3.1-2.9-7.7-2.9-13.2.1-14 10.7-28.2 28.1-28.2 14.4-.1 27.9 10.1 27.9 28.2 0 2.1-.4 4.3-.8 6.3 4-4.6 4.3-8.6 4.3-11.3l.2-1.3ZM68.4 45.3c-6.9 0-13.6 5.7-13.6 13.2 0 6.9 5.1 14.1 13.6 14.2 7.6.1 13.4-5.4 13.5-12.7.2-8.3-5.9-14.7-13.5-14.7Z"
    />
  </SvgIcon>
);

export default FaheemMark;
